import React, { useState, useEffect } from 'react';
import Select from 'react-select'
import * as styles from '../../../config/styles'
import $ from 'jquery'
import { useLocalStorage } from "@uidotdev/usehooks"

const StatusOptionsMulti = (props) => {
    const tableRef = props.tableRef
    const statusColumnIndex = props.statusColumnIndex
    const placeholder = (props.placeholder || 'Select Status...')
    const storageKey = props.localStorageKey
    const statusColumnIsMulti = props.statusColumnIsMulti
    const data = props.data
    const fetchUrl = props.fetchUrl
    const objectFilterCb = props.objectFilterCb
    
    const [ options, setOptions ] = useState([])
    const [ values, setValues ] = useLocalStorage(storageKey,[])
    
    useEffect(() => {
        // If there's nothing stored in localStorage, keep values empty
        // empty values === all selected. Just cleaner
        let values = []
        try {
            values = JSON.parse(localStorage.getItem(storageKey))
        } catch(err) {
            console.log('Error getting key from localStorage: ' + err);
        }
        setValues(values)

        if( typeof(data) !== 'undefined' ) {
            setOptions(data)
            return
        }
        
        fetch(fetchUrl, { credentials: 'same-origin' })
            .then(function(response) {
                return response.json();
            })
            .then(function(json) {
                if( objectFilterCb ) {
                    json.results = json.results.filter(objectFilterCb)
                }
                setOptions(json.results)

            })
    }, [data, fetchUrl])

    useEffect(() => {
        // TODO figure out how to do this with tableRef.
//        tableRef.current?.dt()?.fn.dataTable.ext.search.push(
        $.fn.dataTable.ext.search = [
            function( settings, data, dataIndex ) {
                const statusValue = data[statusColumnIndex]

                if (typeof options === 'undefined') {
                    return false
                }
                
                const statusFilter = values
                if (statusFilter === null || typeof statusFilter === 'undefined' || statusFilter.length === 0) {
                    // default to show all
                    return true
                }

                // If the statusValue is an array, we need to check each value
                const isArray = statusColumnIsMulti || false
                if( isArray ) {
                    const values = statusValue.split(/,\s/)
                    const res = values.filter(value => {
                        const hasStatus = (element) => element.value === value
                        if( statusFilter.some(hasStatus) ) {
                            return true
                        }
                    })
                    // Use this one if ALL values in the table matches the filter (AND)
                    //if( res.length == statusFilter.length ) {
                    //    return true
                    //}
                    // Use this is ANY value in the table is a match to the filters (OR)
                    if( res.length > 0 ) {
                        return true
                    }
                }
                else {
                    const hasStatus = (element) => element.label === statusValue
                    if( statusFilter.some(hasStatus) ) {
                        return true
                    }
                }

                return false
            }
        ]
        return () => {
            // Clear the filtering
            $.fn.dataTable.ext.search = []
        }
    }, [tableRef, values])

    useEffect(() => {
        tableRef?.current?.dt()?.draw('')
    }, [values])

    return (
        <div className="col-sm-6 m-b-xs">
            <Select
                key="status-options-multi"
                isMulti={true}
                options={options}
                value={values}
                onChange={values => setValues(values) }
                styles={styles.multiSelect}
                closeMenuOnSelect={false}
                placeholder={placeholder}
            />
        </div>
    );
}

export default StatusOptionsMulti
